// extracted by mini-css-extract-plugin
export default {"reset__description":"ResetPassword_reset__description__s22WD"};